// extracted by mini-css-extract-plugin
export default {"continue":"cart_continue__xIjja"};